import { render, staticRenderFns } from "./InboundOutboundForecast.vue?vue&type=template&id=774db9d7"
import script from "./InboundOutboundForecast.vue?vue&type=script&lang=js"
export * from "./InboundOutboundForecast.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports